export type BookingSettingsTabId =
  | 'form'
  | 'projects'
  | 'destinations'
  | 'costCenters'
  | 'costSettings'
  | 'tripPurposes'
  | 'terms';

export const BOOKING_SETTINGS_TAB_IDS: BookingSettingsTabId[] = [
  'form',
  'projects',
  'destinations',
  'costCenters',
  'costSettings',
  'tripPurposes',
  'terms',
];

export function isBookingSettingsTabId(value: string | null): value is BookingSettingsTabId {
  return value != null && (BOOKING_SETTINGS_TAB_IDS as string[]).includes(value);
}

export function tabLabel(tab: BookingSettingsTabId, t: (key: string) => string): string {
  switch (tab) {
    case 'form':
      return t('booking.tabFormFields');
    case 'projects':
      return t('booking.tabProjectImport');
    case 'destinations':
      return t('booking.tabDestinations');
    case 'costCenters':
      return t('booking.tabCostCenters');
    case 'costSettings':
      return t('booking.tabCostSettings');
    case 'tripPurposes':
      return t('booking.tabTripPurposes');
    case 'terms':
      return t('booking.tabTerms');
    default:
      return tab;
  }
}

/** Feature VIEW krävs för fliken (BOOKING_SETTINGS ger tillgång till alla). */
export function tabFeatureCode(tab: BookingSettingsTabId): string {
  switch (tab) {
    case 'form':
    case 'projects':
      return 'BOOKING_SETTINGS';
    case 'destinations':
      return 'BOOKING_DESTINATIONS';
    case 'costCenters':
      return 'BOOKING_COST_CENTERS';
    case 'costSettings':
      return 'BOOKING_COST_SETTINGS';
    case 'tripPurposes':
      return 'BOOKING_TRIP_PURPOSES';
    case 'terms':
      return 'BOOKING_TERMS';
    default:
      return 'BOOKING_SETTINGS';
  }
}

export function canAccessBookingSettingsTab(
  tab: BookingSettingsTabId,
  hasFeatureAccess: (code: string) => boolean
): boolean {
  if (hasFeatureAccess('BOOKING_SETTINGS')) return true;
  return hasFeatureAccess(tabFeatureCode(tab));
}

export const BOOKING_SETTINGS_ROUTE_FEATURES = [
  'BOOKING_SETTINGS',
  'BOOKING_DESTINATIONS',
  'BOOKING_COST_CENTERS',
  'BOOKING_COST_SETTINGS',
  'BOOKING_TRIP_PURPOSES',
  'BOOKING_TERMS',
] as const;
